export function safeNotificationRoute(value, role) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\r\n]/.test(value)) return null;
  let url;
  try { url = new URL(value, 'https://portal.invalid'); } catch { return null; }
  if (url.origin !== 'https://portal.invalid') return null;
  const path = url.pathname;
  if (role === 'client') return /^\/client\/dashboard(?:\/|$)/.test(path) ? `${path}${url.search}${url.hash}` : null;
  if (role !== 'firm') return null;
  return /^(?:\/case\/[\w-]+(?:\/|$)|\/(?:dashboard|todays-todos|341-workboard|reaffirmation-workboard|case-search|account|notifications)(?:\/|$))/.test(path)
    ? `${path}${url.search}${url.hash}` : null;
}

export function sessionRole(storage = localStorage) {
  if (storage.getItem('clientToken')) return 'client';
  if (storage.getItem('accessToken') || storage.getItem('refreshToken')) return 'firm';
  return null;
}
